export default __webpack_public_path__ + "static/media/campaigns_icon.f325e865.svg";